import { Component } from '@angular/core';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-gantt-legend',
  templateUrl: './gantt-legend.component.html',
  styleUrls: ['./gantt-legend.component.scss']
})
export class GanttLegendComponent {

  constructor(public translationService: TranslationService) {}

}
